// Styles
import './alternative-one.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initAlternativeOne = (context) => {
  const alternativeOneSection = context.closest('.shopify-section');
  if (!alternativeOneSection) return;

  const slidesContainer = alternativeOneSection.querySelector('.alternative-one-slider');
  const slides = slidesContainer.querySelectorAll('.alternative-one-slider .swiper-slide');
  const slidesCount = slides.length;

  if (slidesCount > 1) {
    const swiper = new Swiper(alternativeOneSection.querySelector('.alternative-one-slider'), {
      loop: false,
      centeredSlides: true,
      slidesPerView: 1.4,
      spaceBetween: 0,
      breakpoints: {
        1025: {
          slidesPerView: 1.35
        },
      },
      navigation: {
        prevEl: alternativeOneSection.querySelector('.swiper-arrow.swiper-arrow-left'),
        nextEl: alternativeOneSection.querySelector('.swiper-arrow.swiper-arrow-right')
      }
    });
  }
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.alternative-one-wrapper'), (el) => {
    window.dAgency.initAlternativeOne(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.alternative-one-wrapper'), (el) => {
      window.dAgency.initAlternativeOne(el);
    });
  });
}
